import { z } from 'zod';

export const CoreIntegrationDataSyncMappingValueScalarFieldEnumSchema = z.enum(['id','cityId','mappingId','createdAt','updatedAt','gogovFieldName','gogovFieldId','gogovValue','externalFieldName','externalFieldId','externalValue']);

export default CoreIntegrationDataSyncMappingValueScalarFieldEnumSchema;
